import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppConstants } from '@constants/app.constant';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  standalone:true,
  imports:[CommonModule,MatProgressSpinnerModule]
})
export class LoaderComponent {
  constants = AppConstants;
  @Input() showText = true;
}
